import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { createOptions } from '@/utils/arrayHelper'
import { camelToWords } from '@/utils/stringHelper'
import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import GCMaterialService from './GCMaterial.service'

const useGCMaterial = () => {
  const service = new GCMaterialService()
  const baseCrud = useCrud(API_RESOURCE.GC_MATERIAL, service)

  const queryClient = useQueryClient()

  const useUploadGCMaterials = () => {
    return useMutation({
      mutationFn: (file) => service.uploadGCMaterial(file),
      onSuccess: (res) => {
        toast.info(`Successfully Upload  ${camelToWords(API_RESOURCE.GC_MATERIAL)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  const useDownloadGCMaterials = () => {
    return useMutation({
      mutationFn: () => service.downloadGCMaterials(),
    })
  }

  const useSearchGCMaterialsByModelNumber = () => {
    return useMutation({
      mutationFn: (modelNumber) => {
        if (modelNumber === '') {
          return {
            mappedDetail: undefined,
            allDetails: [],
          }
        }

        return service.searchByModelNumber(modelNumber)
      },
    })
  }

  const useGCMaterialOptions = (payload = {}) => {
    const { status = 'active', valueKey = '_id' } = payload
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status: status } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status: status } }),
      placeholderData: keepPreviousData,
      select: (data) => {
        return createOptions(data?.data?.results, 'name', valueKey)
      },
    })
  }

  return {
    //Base CRUD
    useFetchAllGCMaterials: baseCrud.useFetchAll,
    useFetchGCMaterial: baseCrud.useFetchOne,
    useCreateGCMaterial: baseCrud.useCreate,
    useUpdateGCMaterial: baseCrud.useUpdate,
    useRemoveGCMaterial: baseCrud.useRemove,

    //Extra
    useUploadGCMaterials,
    useDownloadGCMaterials,
    useSearchGCMaterialsByModelNumber,
    useGCMaterialOptions,
  }
}

export default useGCMaterial
